import { useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { type ITabItem, Tabs } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversationRoutes } from 'pages/conversations/route/type'
import styles from './styles.module.scss'

export const ConversationTabs = observer(() => {
  const { usersStore, inboxesStore } = useEntitiesContext()
  const isShouldRequestAccess = !!usersStore.user?.isShouldRequestAccess
  const { pathname } = useLocation()
  const unreadConversations = inboxesStore.currentInbox?.unread ? 1 : undefined
  const unreadCalls = inboxesStore.currentInbox?.unread_calls ? 1 : undefined
  const tabs: ITabItem<'chats' | 'calls'>[] = useMemo(() => {
    return [
      {
        key: 'chats',
        name: 'Chats',
        icon: 'conversation',
        count: unreadConversations,
        badgeProps: {
          type: 'dot',
        },
      },
      {
        key: 'calls',
        name: 'Calls',
        icon: 'phone',
        count: unreadCalls,
        badgeProps: {
          type: 'dot',
        },
      },
    ]
  }, [unreadConversations, unreadCalls])

  const activeTab = pathname.includes('calls') ? 'calls' : 'chats'

  if (isShouldRequestAccess) return null

  const selectTab = (tab: ITabItem<'chats' | 'calls'>) => {
    if (tab.key === 'calls') {
      uiStore.changeRoute({
        path: `/${ConversationRoutes.root}/${ConversationRoutes.calls}`,
      })
    }
    if (tab.key === 'chats') {
      uiStore.changeRoute({
        path: `/${ConversationRoutes.root}`,
      })
    }
  }

  if (inboxesStore.localInboxes.hasQuickFilter) return null
  if (inboxesStore.localInboxes.hasSmartViewFilter) return null

  return (
    <div className={styles.tabs}>
      <Tabs
        tabs={tabs}
        activeTabKey={activeTab}
        handleSelectTab={selectTab}
        variant={'simple'}
        size={'large'}
        isFullWidth
        badgeActive={true}
        tabsClassName={styles.tabs}
      />
    </div>
  )
})
